const r=r=>null==r?void 0:r.name,e=e=>(n,o,c)=>{try{return e(n,o,c)}catch(n){return console.error(["Error: An error occurred while building a breadcrumb item",`Reference: ${r(e)}`,`Message: ${n}`].join("\n")),[]}};export{e as default};
